import { render } from "./editarSiniestro.vue?vue&type=template&id=6881da2a&scoped=true"
import script from "./editarSiniestro.vue?vue&type=script&lang=js"
export * from "./editarSiniestro.vue?vue&type=script&lang=js"

import "./editarSiniestro.vue?vue&type=style&index=0&id=6881da2a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6881da2a"]])

export default __exports__